import { render, staticRenderFns } from "./DetailSettings.vue?vue&type=template&id=0abec93b&scoped=true&"
import script from "./DetailSettings.vue?vue&type=script&lang=js&"
export * from "./DetailSettings.vue?vue&type=script&lang=js&"
import style0 from "./DetailSettings.vue?vue&type=style&index=0&id=0abec93b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abec93b",
  null
  
)

export default component.exports